export const Radio = ({ label, value, checked, onChange, className = '' }) => {
  return (
    <label className={`group flex cursor-pointer items-center space-x-2 ${className}`}>
      <div className="relative">
        <input
          type="radio"
          value={value}
          checked={checked}
          onChange={onChange}
          className="sr-only shadow"
        />
        <div
          className={`h-5 w-5 rounded-full border bg-white/50 shadow drop-shadow-sm group-hover:bg-white/80 group-hover:shadow-md ${checked ? 'border-accent-400' : 'border-white/50'} bg-white/30 backdrop-blur-sm transition-all`}
        ></div>
        {checked && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="bg-accent-400 shadow-glow-sm h-3 w-3 rounded-full"></div>
          </div>
        )}
      </div>
      <span className="text-sm font-medium text-gray-700">{label}</span>
    </label>
  )
}
